import { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";

export const SummaryCards = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    adminApi.get("/admin/summary").then((r) => setS(r.data)).catch(() => {});
  }, [refreshKey]);

  const cards = s ? [
    { id: "employer-total", label: "Employer requests", value: s.employer.total, sub: `${s.employer.today} today · ${s.employer.verified} verified` },
    { id: "worker-total", label: "Employee sign-ups", value: s.worker.total, sub: `${s.worker.today} today · ${s.worker.verified} verified` },
  ] : [];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {cards.map((c) => (
        <div key={c.id} data-testid={`admin-summary-${c.id}`} className="border border-white/10 bg-[#0F172A] p-5">
          <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">{c.label}</p>
          <p className="mt-2 font-heading text-4xl font-extrabold text-white">{c.value}</p>
          <p className="mt-1 text-sm text-slate-500">{c.sub}</p>
        </div>
      ))}
    </div>
  );
};
